import { render, staticRenderFns } from "./NetWeightPerPackageInput.vue?vue&type=template&id=d9fad208&scoped=true"
import script from "./NetWeightPerPackageInput.vue?vue&type=script&lang=ts"
export * from "./NetWeightPerPackageInput.vue?vue&type=script&lang=ts"
import style0 from "./NetWeightPerPackageInput.vue?vue&type=style&index=0&id=d9fad208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fad208",
  null
  
)

export default component.exports